$(document).ready(function () {
  $(".used-products-wrapper .grid-product-slider").each(function (index, wrapper) {
    const $parent = $(wrapper).parent();
    $(wrapper).slick({
      dots: true,
      infinite: false,
      arrows: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: $parent.find(".btn-slick-prev"),
      nextArrow: $parent.find(".btn-slick-next"),
      dotsClass: "custom_paging",
      cssEase: "linear",
      customPaging: function (slider, i) {
        return i + 1 + " / " + Math.ceil(slider.slideCount - 3);
      },
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            customPaging: function (slider, i) {
              return i + 1 + " / " + Math.ceil(slider.slideCount - 2);
            },
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            customPaging: function (slider, i) {
              return i + 1 + " / " + Math.ceil(slider.slideCount - 1);
            },
          },
        },
      ],
    });
  });

  if ($(".video-wrapper").length > 0) {
    $(".video-wrapper").on("click", function () {
      $(this).addClass("active");
      const $iframe = $(this).find("iframe");
      const src = $iframe.attr("src");
      if (!src.includes("autoplay=1")) {
        $iframe.attr("src", src + "&autoplay=1");
      }
    });
  }
  if ($(".article-template__content .tabs-wrapper").length > 0) {
    $(".article-template__content .tabs-wrapper .tab").on("click", function () {
      $(".tab").removeClass("active");
      $(this).addClass("active");
      $(".tab-panel").removeClass("active");
      const targetPanel = $(this).data("tab");
      $("#" + targetPanel).addClass("active");
      if ($(this).hasClass('qna-tab')) {
        $('.article-faq').addClass('hide'); 
      } else {
        $('.article-faq').removeClass('hide');
      }
      if ($(".used-products-wrapper.active").length > 0) {
        $(".used-products-wrapper .grid-product-slider").slick("refresh");
      }
    });
  }
});

/* ====================== Featucher Blog Start ====================== */
$(document).ready(function () {
  $(".featucherblog .blog-articles").each(function (index, wrapper) {
    const $parent = $(wrapper).parent();

    $(wrapper).slick({
      dots: true,
      infinite: false,
      arrows: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: $parent.find(".btn-slick-prev"),
      nextArrow: $parent.find(".btn-slick-next"),
      dotsClass: "custom_paging",
      cssEase: "linear",
      customPaging: function (slider, i) {
        return i + 1 + " / " + Math.ceil(slider.slideCount - 3);
      },
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            customPaging: function (slider, i) {
              return i + 1 + " / " + Math.ceil(slider.slideCount - 2);
            },
          },
        },
        {
          breakpoint: 768,
          settings: "unslick" // This will disable Slick on screens below 768px
        }
        // {
        //   breakpoint: 768,
        //   settings: {
        //     settings: "unslick"
        //     slidesToShow: 2,
        //     slidesToScroll: 1,
        //     customPaging: function (slider, i) {
        //       return i + 1 + " / " + Math.ceil(slider.slideCount - 1);
        //     },
        //   },
        // },
        // {
        //   breakpoint: 450,
        //   settings: {
        //     slidesToShow: 1.5,
        //     slidesToScroll: 1,
        //     customPaging: function (slider, i) {
        //       return i + 1 + " / " + Math.ceil(slider.slideCount - 0.5);
        //     },
        //   },
        // },
      ],
    });
  });
});

/* ====================== banner slider section Start ====================== */
let currentIndex = 0;
const slideDuration = 5000;
let slideInterval;
let progressInterval;
let percentTime = 0;

const slider = document.querySelector(".slider");
const slides = document.querySelectorAll(".slide");
const slideNumberElement = document.querySelector(".slider-number p");
const totalSlides = slides.length;
const progressCircle = document.querySelector(".progress-ring circle");

const circleLength = 157;

function updateSlide() {
  if (!slider || slides.length === 0) return;

  currentIndex = (currentIndex + slides.length) % slides.length;
  slider.style.transform = `translateX(-${currentIndex * 100}%)`;

  updateSlideNumber();
  resetProgressBar();
}

function updateSlideNumber() {
  if (slideNumberElement) {
    slideNumberElement.textContent = `${currentIndex + 1}/${totalSlides}`;
  }
}

function resetProgressBar() {
  percentTime = 0;
  progressCircle.style.strokeDashoffset = circleLength;
  progressCircle.style.transition = "none";

  setTimeout(() => {
    progressCircle.style.transition = "stroke-dashoffset 5s linear";
    progressCircle.style.strokeDashoffset = 0;
  }, 50);

  clearTimeout(progressInterval);
  progressInterval = setTimeout(() => {
    nextSlide();
  }, slideDuration);
}

function startAutoSlide() {
  slideInterval = setInterval(() => {
    nextSlide();
  }, slideDuration);
  resetProgressBar();
}

function restartAutoSlide() {
  clearInterval(slideInterval);
  clearTimeout(progressInterval);
  startAutoSlide();
}

function nextSlide() {
  currentIndex++;
  updateSlide();
  restartAutoSlide();
}

function prevSlide() {
  currentIndex--;
  updateSlide();
  restartAutoSlide();
}

document.addEventListener("DOMContentLoaded", () => {
  if (progressCircle) {
    updateSlideNumber();
    startAutoSlide();
  }
});

/* ====================== mani-university tab  slider section Start ====================== */
  $(document).ready(function () {
    $('.tutorial-toggle-input').on('change', function () {
      var category = $(this).attr('data-category');
      var $parents = $(this).parents(".steps-wrap");
      if ($(this).is(':checked')) {
        // Video selected
        console.log('Step-by-step view');
        $parents.find('.tutorial-content').removeClass('active');
        $parents.find('.tutorial-content-video').addClass('active');
      } else {
        // Step-by-step Tutorial selected
        console.log('Video Tutorial view');
        $parents.find('.tutorial-content').removeClass('active');
        // const $slider = $('.tutorial-content.active .steps-slider');
        const $slider = $parents.find('.tutorial-content-step .steps-slider');
        if ($slider.hasClass('slick-slider')) {
          // $slider.slick('refresh');
          setTimeout(function () {
             $slider.slick('setPosition');
          },0);
        } else {
          slickSliderEvent(slider);
        }
        $parents.find('.tutorial-content-step').addClass('active');
      }
    });
  
  const $tabs = $(".tab-n");
  const $articles = $(".article-wrap");
  const $steps = $(".steps-wrap");
  const $titleElement = $("#tutorialTitle");
  const $article = $(".articles-wrap");
  const $Stepscontent = $(".Steps-content");
    
  function showCategory(name) {
    let firstArticle = null;

    // Show/hide articles and set first active
    $articles.each(function() {
      const $article = $(this);
      const articleName = $article.data("name");
      const shouldShow = (name === "all" || articleName === name);

      $article.css("display", shouldShow ? "block" : "none").removeClass("active");

      if (shouldShow && !firstArticle) {
        firstArticle = $article;
      }
    });

    // Set first one active
    if (firstArticle) {
      firstArticle.addClass("active");
    }

    // Hide all steps
    $steps.css("display", "none");

    // Show only the matching steps for the first visible article
    if (firstArticle) {
      const firstName = firstArticle.data("category");
      $steps.each(function() {
        const $step = $(this);
        $step.css("display", ($step.data("category") === firstName) ? "block" : "none");
      });
    }
  }

  function handleArticleClick() {
    $articles.on("click", function() {
      const selectedName = $(this).data("category");

      $articles.removeClass("active");
      $(this).addClass("active");

      $steps.each(function() {
        const $step = $(this);
        $step.css("display", ($step.data("category") === selectedName) ? "block" : "none");
      });
       const $slider = $('.tutorial-content.active .steps-slider');
        if ($slider.hasClass('slick-slider')) {
          $slider.slick('refresh');
        } else {
          slickSliderEvent(slider);
        }
    });
  }
  
  $tabs.on("click", function(e) {
    e.preventDefault();
    $tabs.removeClass("active");
    $(this).addClass("active");
    // $article.removeClass("show-visibale");
    // $Stepscontent.removeClass("show-visibale");

    const $allTab = $tabs.filter('[data-category="all"]');
    const isAllTab = $(this).data("category") === "all";

    if ($(this).attr('data-category') == 'all') {
      $allTab.addClass("show-all-visible");
      $article.addClass("show-all-visible");
      $Stepscontent.addClass("show-all-visible");
    } else {
      $allTab.removeClass("show-all-visible");
      $article.removeClass("show-all-visible");
      $Stepscontent.removeClass("show-all-visible");
    }
    
    const selectedName = $(this).data("name") || "all";
    if ($titleElement.length) {
      $titleElement.text( $(this).text());
    }

    showCategory(selectedName);
    const $slider = $('.tutorial-content.active .steps-slider');
        if ($slider.hasClass('slick-slider')) {
          $slider.slick('refresh');
        } else {
          slickSliderEvent(slider);
        }
  });

  showCategory("all");
  handleArticleClick();
});

/* ===---------------- tab  slider ----------------- */
function slickSliderEvent(selecter) {
const $slider = $(selecter); // make sure it's a jQuery object
const $parent = $slider.closest(".tutorial-content"); // define $parent here
  $slider.slick({
    dots: true,
    infinite: false,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: $parent.find(".btn-slick-prev"),
    nextArrow: $parent.find(".btn-slick-next"),
    dotsClass: "custom_paging",
    cssEase: "linear",
    customPaging: function (slider, i) {
      return (i + 1) + " / " + Math.ceil(slider.slideCount -3);
    },
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          customPaging: function (slider, i) {
            return (i + 1) + " / " + Math.ceil(slider.slideCount -2);
          }
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          customPaging: function (slider, i) {
            return (i + 1) + " / " + Math.ceil(slider.slideCount -1);
          }
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          customPaging: function (slider, i) {
            return (i + 1) + " / " + Math.ceil(slider.slideCount);
          }
        }
      }
    ]
  });
}

$(document).ready(function () {
  $(".tutorial-content .steps-slider").each(function (index, slider) {
    slickSliderEvent(slider); // this will now work correctly
  });
});
/* ===----------------New Design Articles page ----------------- */

/* ===----------------Related Articles slider ----------------- */

$(document).ready(function () {
  $(".related-articles .featucherblog.re-articale .blog-article").each(function (index, wrapper) {
    const $parent = $(wrapper).parent();

    $(wrapper).slick({
      dots: true,
      infinite: false,
      arrows: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: $parent.find(".btn-slick-prev"),
      nextArrow: $parent.find(".btn-slick-next"),
      dotsClass: "custom_paging",
      cssEase: "linear",
      customPaging: function (slider, i) {
        return i + 1 + " / " + Math.ceil(slider.slideCount - 3);
      },
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            customPaging: function (slider, i) {
              return i + 1 + " / " + Math.ceil(slider.slideCount - 2);
            },
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            customPaging: function (slider, i) {
              return i + 1 + " / " + Math.ceil(slider.slideCount - 1);
            },
          },
        },
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '30px',
            customPaging: function (slider, i) {
              return i + 1 + " / " + Math.ceil(slider.slideCount - 0.5);
            },
          },
        },
      ],
    });
  });
});

/* ===----------------Table of Content  ----------------- */
$(document).ready(function () {
 const $content = $(".article-body");
  const $tocList = $(".toc-list-data");
  const $tocToggle = $(".toc-toggle-data");
  const $iconPlus = $(".toc-icon-plus");
  const $iconMinus = $(".toc-icon-minus");

  if (!$content.length || !$tocList.length || !$tocToggle.length) return;

  $tocToggle.on("click", function () {
    $tocList.toggleClass("toc-hidden toc-visible");

    const isHidden = $tocList.hasClass("toc-hidden");

    // Toggle icons
    if (isHidden) {
      $iconMinus.addClass("hidden");
      $iconPlus.removeClass("hidden");
    } else {
      $iconPlus.addClass("hidden");
      $iconMinus.removeClass("hidden");
    }
  });
  // Auto TOC generation
  const $headings = $content.find("h2, h3 ,.educational h3.h3-title ,.comparison h3.h3-title");

  $headings.each(function (index) {
    const $heading = $(this);
    let text = $heading.text().trim();

    if (["What You Need", "Before You Start", "Innan du börjar"].includes(text)) return;

    const cleanText = text
      .replace(/[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu, "")
      .replace(/[^\p{L}\p{N}\s.:-]/gu, "")
      .trim();

    const id = "step-" + index + "-" + cleanText
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w.-]+/g, "");

    $heading.attr("data-id", id);

    // Match number followed by a period or decimal point
    const match = cleanText.match(/^(\d+(?:\.\d+)?)\s*[.:–-]/);
    const stepLabel = match ? `Vaihe ${match[1]} ` : "";

    // Remove the number and punctuation for the rest of the text
    const linkText = match
      ? stepLabel + cleanText.replace(/^(\d+(?:\.\d+)?)\s*[.:–-]*\s*/, '')
      : cleanText;

    const $li = $("<li></li>");
    $li.html(`<a href="#${id}">${linkText}</a>`);
    $tocList.append($li);
  });
});


  
$(document).ready(function () {
  $('.toc-list-data').on('click', 'a', function (e) {
    e.preventDefault();

    let targetId = $(this).attr('href').replace(/^#/, '');
    const $target = $('[data-id="' + targetId + '"]');

    if ($target.length) {
      const headerHeight = $('.header').outerHeight() || 0;
      const targetOffset = $target.offset().top;

      $('html, body').animate({
        scrollTop: targetOffset - headerHeight
      }, 600);
    }

    // Remove previous highlights
    $('.toc-list-data li').removeClass('active-li active');

    // Add highlight to clicked <li> and all <li> above it
    const $clickedLi = $(this).closest('li');
    $clickedLi.addClass('active-li active');
    $clickedLi.prevAll('li').addClass('active-li');
  });
});


$(window).on('scroll', function () {
  const scrollTop = $(window).scrollTop();
  const headerHeight = $('.header').outerHeight() || 0;
  let currentId = null;

  $('.article-body h2, .article-body h3').each(function () {
    const offsetTop = $(this).offset().top - headerHeight - 10;
    if (scrollTop >= offsetTop) {
      currentId = $(this).attr('data-id');
    }
  });

  if (currentId) {
    // Remove all highlights
    $('.toc-list-data li').removeClass('active-li active');

    // Highlight current + all above
    const $activeItem = $('.toc-list-data a[href="#' + currentId + '"]').closest('li');
    $activeItem.addClass('active-li active');
    $activeItem.prevAll('li').addClass('active-li');
  }
});


/* Result page tab */
$(document).ready(function(){
  $('.result-tabs-nav .tab-item').click(function() {
    $('.result-tabs-nav li').removeClass('active');
    $(this).parent().addClass('active');
    var currentTab = $(this).attr('data-tab');
    if (currentTab === 'All') {
      $('.wrapper-block-result').show(); 
    } else {
      $('.wrapper-block-result').hide(); 
      $('.wrapper-block-result[data-type="' + currentTab + '"]').show(); 
    }
    return false; 
  });
  if($('.image-with-text-wrapper .image-text-slide').length > 0) {
    $('.image-with-text-wrapper .image-text-slide').slick({
      arrows: true,
      dots: true,
      autoplay: true,
      prevArrow: $('.custom-slick-prev'),
      nextArrow: $('.custom-slick-next')
    });
  }
});


if($('.image-with-text-slider').length > 0) {
  $('.image-with-text-slider').slick({
    autoplay: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: $('.desktop-custom-slick-prev'),
    nextArrow: $('.desktop-custom-slick-next'),
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 790,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          prevArrow: $('.custom-arrow-wrapper .custom-slick-prev'),
          nextArrow: $('.custom-slick-next')
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: $('.custom-slick-prev'),
          nextArrow: $('.custom-slick-next')
        }
      }
    ]
  });
}

$(document).on("click", ".faq-2", function () {
  $(this).find(".faq-icon").toggleClass("faq-icon-rotate");
  $(this).next(".faq-content").slideToggle();
});
